
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6IuC5hOC4oeC5iOC4iOC4s+C5gOC4m+C5h+C4meC4leC5ieC4reC4h+C4o+C4sOC4muC4uCJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6IuC5hOC4oeC5iOC4iOC4s+C5gOC4m+C5h+C4meC4leC5ieC4reC4h+C4o+C4sOC4muC4uCJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wc2lvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wc2lvbmFsIn0=!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wdGlvbmFsIn0=!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6IuC5hOC4oeC5iOC4iOC4s+C5gOC4m+C5h+C4meC4leC5ieC4reC4h+C4o+C4sOC4muC4uCJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6IuC5hOC4oeC5iOC4iOC4s+C5gOC4m+C5h+C4meC4leC5ieC4reC4h+C4o+C4sOC4muC4uCJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wc2lvbmFsIn0=!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6Im9wc2lvbmFsIn0=!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6IlvDtsO2xqXhua/DrMOsw7bDtuC4geC4teC5icSDxIPGml0ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJwYWdlLXNlY3Rpb24tb3B0aW9uYWwtdGV4dCI6IlvDtsO2xqXhua/DrMOsw7bDtuC4geC4teC5icSDxIPGml0ifQ==!"
        )
      )
      });
  
      export { translations as default };
    